import PropTypes from 'prop-types'

export function buildBandwidthSupportMailtoHref({
  hotelName,
  displayId,
  placesId,
  streetAddress,
  city,
  stateCode,
  postalCode,
  countryCode,
  latitude,
  longitude,
  invoiceAddress,
  errorDetail
}) {
  const subject = 'Unable to add subaccount - address issue'
  const resolvedError =
    errorDetail ||
    '12113, The provided street address could not be verified. Please submit a valid street address'
  const body = [
    'Hi,',
    '',
    'We have the following details to add but it fails due to address issues.',
    '',
    `"HotelName": ${hotelName ?? ''},`,
    `"DisplayId": ${displayId ?? ''},`,
    `"PlacesId": ${placesId ?? ''},`,
    `"StreetAddress": ${streetAddress ?? ''},`,
    `"City": ${city ?? ''},`,
    `"StateCode": ${stateCode ?? ''},`,
    `"PostalCode": ${postalCode ?? ''},`,
    `"CountryCode": ${countryCode ?? ''},`,
    `"Latitude": ${latitude ?? ''},`,
    `"Longitude": ${longitude ?? ''},`,
    `"Address": ${invoiceAddress ?? ''},`,
    `Error we get is the following: "${resolvedError}"`,
    '',
    'Please update us, once you define this address.'
  ].join('\n')

  return `mailto:911support@bandwidth.com?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`
}

const MailLink = ({
  hotelName,
  displayId,
  placesId,
  streetAddress,
  city,
  stateCode,
  postalCode,
  countryCode,
  latitude,
  longitude,
  invoiceAddress,
  errorDetail,
  className,
  children
}) => {
  const href = buildBandwidthSupportMailtoHref({
    hotelName,
    displayId,
    placesId,
    streetAddress,
    city,
    stateCode,
    postalCode,
    countryCode,
    latitude,
    longitude,
    invoiceAddress,
    errorDetail
  })

  const openMail = event => {
    event.preventDefault()
    event.stopPropagation()
    window.location.href = href
  }

  return (
    <a className={className} href={href} onClick={openMail}>
      {children}
    </a>
  )
}

MailLink.propTypes = {
  hotelName: PropTypes.string,
  displayId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placesId: PropTypes.string,
  streetAddress: PropTypes.string,
  city: PropTypes.string,
  stateCode: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  invoiceAddress: PropTypes.string,
  errorDetail: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
}

export default MailLink
